export default {"src":"/org/_next/static/media/international.ad1996aa.svg","height":12,"width":14,"blurWidth":0,"blurHeight":0};